import { i18nextInstance as i18n, namespaces } from 'common/config/i18next'
import { capitalise } from 'common/config/helpers'
import { ToastContent } from 'react-toastify'

type GraphQLErrorLike = {
  graphQLErrors?: { message?: string }[]
}

export const errorMessageFromGraphQL = (error: unknown) => ({
  type: 'error',
  message: (error as GraphQLErrorLike)?.graphQLErrors?.[0]?.message,
})

export const errorMessage = (message: ToastContent) => ({
  type: 'error',
  message,
})

export const infoMessage = (message: ToastContent) => ({
  type: 'info',
  message,
})

export const successMessage = (message: ToastContent) => ({
  type: 'success',
  message,
})

export const warningMessage = (message: ToastContent) => ({
  type: 'warning',
  message,
})

export const createdMeggage = (entity: (typeof namespaces)[number]) => {
  const message = `${i18n.t(`${entity}:entity_one`)} ${i18n.t('notification:created')}`

  return `${capitalise(message)} ✅`
}

export const deletedMessage = (entity: (typeof namespaces)[number]) => {
  const message = `${i18n.t(`${entity}:entity_one`)} ${i18n.t('notification:deleted')}`

  return `${capitalise(message)} 🗑`
}

export const savedMessage = (entity: (typeof namespaces)[number]) => {
  const message = `${i18n.t(`${entity}:entity_one`)} ${i18n.t('notification:saved')}`

  return `${capitalise(message)} 💾`
}
